import styled from 'styled-components';

import { formatNumber } from '@/shared/utils';
import { breakpoints } from '@/shared/styles';
import { RESTAKE_SUPPORTED_NETWORKS } from '@/core/config';
import { getVaults } from '@/features/vaults/utils/getVaults';
import { calculateTVL } from '@/shared/utils/calculateTVL';
import { useVaultsData } from '@/features/vaults/hooks/useVaultsData';
import { pointsDomains } from '@/features/vaults/config';

const Container = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;

  padding: 0 20px;
  margin-top: 60px;
  height: 160px;

  font-family: Gramatika;
  font-weight: 400;

  @media (min-width: ${breakpoints.tabletSM}px) {
    gap: 20px;

    padding: 0 16px;
    height: 310px;
    flex-direction: row;
    margin-top: 180px;
  }

  @media (min-width: ${breakpoints.laptopSM}px) {
    padding: 0;
  }

  h4 {
    font-size: 15px;
    line-height: 120%;

    @media (min-width: ${breakpoints.tabletSM}px) {
      font-size: 28px;
    }
  }

  span {
    font-size: 24px;
    line-height: 100%;

    @media (min-width: ${breakpoints.tabletSM}px) {
      font-size: 64px;
    }
  }

  .Metric__container {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    height: 100%;
    gap: 10px;

    padding-left: 10px;

    border-left: 2px solid rgba(255, 19, 66, 1);

    @media (min-width: ${breakpoints.tabletSM}px) {
      padding-left: 20px;
    }
  }
`;

const allVaults = getVaults(RESTAKE_SUPPORTED_NETWORKS);

export const Metrics = () => {
  const { data: vaultsData } = useVaultsData({ pointsDomain: pointsDomains.prod, enabled: true });

  const tvl = calculateTVL(vaultsData);
  const vaultsCount = allVaults.length;
  const curatorsCount = Array.from(new Set(allVaults.flatMap(vault => vault.curators))).length;

  return (
    <Container>
      <div className="Metric__container">
        <h4>Total Value Locked</h4>
        <span>{tvl != null ? `$${formatNumber(tvl)}` : '—'}</span>
      </div>

      <div className="Metric__container">
        <h4>Vaults</h4>
        <span>{vaultsCount}</span>
      </div>

      <div className="Metric__container">
        <h4>Curators</h4>
        <span>{curatorsCount}</span>
      </div>
    </Container>
  );
};
